<template>
  <div class="container-fluid" id="app">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <router-link class="navbar-brand" to="/">
        <!-- <i class="far fa-books"></i> -->
        <img src="@/assets/book-256.png" alt="Logo" width="25px" />
        <em class="ml-2">Livio's Library</em>
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li v-if="isLogged" class="nav-item">
            <router-link class="nav-link " to="/library">Library</router-link>
          </li>

          <li v-if="isLogged" class="nav-item">
            <router-link class="nav-link " to="/authors">Index</router-link>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              href="#"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Theme
            </a>
            <div class="dropdown-menu">
              <a
                class="dropdown-item text-capitalize"
                href="#"
                v-for="theme in themes"
                :key="theme"
                @click.prevent="changeStyle(theme)"
              >
                {{ theme }}
              </a>
            </div>
          </li>
        </ul>

        <form v-if="isLogged" class="form-inline  ">
          <em class="nav-link pl-0  text-dark" href="/logout">
            <span class="d-none d-sm-inline">Ciao, {{ getName }} -</span>
            <a
              href=""
              class="text-dark font-weight-bold pl-0 pr-1 "
              @click.prevent="logout"
            >
              Logout &nbsp;
              <i
                class="far fa-power-off"
                style="vertical-align: middle"
              ></i>
            </a>
          </em>
        </form>
        <form v-else class="form-inline">
          <!-- <a class="nav-link pl-0  " @click="logout"> - Logout</a> -->
          <em>Ciao, Guest</em>
        </form>
      </div>
    </nav>

    <notifications
      class="m-4 warn"
      width="20%"
      position="top center"
      group="notif"
    />

    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      themes: [
        "superhero",
        "flatly",
        "sandstone",
        "slate",
        "darkly",
        "cerulean",
        "sketchy",
        "simplex",
        "yeti"
      ],
      activeTheme: ""
    };
  },
  methods: {
    changeStyle(theme) {
      var sheet = "/css/" + theme + "/bootstrap.min.css";
      document.getElementById("pagestyle").setAttribute("href", sheet);
      $cookies.set("theme", theme, Infinity);

      this.activeTheme = theme;
      this.$store.commit("setActiveTheme", theme);
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    }
  },
  computed: {
    ...mapGetters(["isLogged", "getName"])
  },
  beforeMount() {
    this.$store.dispatch("verifyAuthStatus");

    this.activeTheme = $cookies.get("theme");
    if (!this.activeTheme) {
      this.activeTheme = "sandstone";
    }
    this.changeStyle(this.activeTheme);
  }
};
</script>

<style></style>
